import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import MainContainer from "../../../layout/MainContainer";
import { DocumentViewer } from "../../../components";
import { Earning, TutorRating } from "../../../features";
import {
  useLazyGetTeachingDetailsByIdQuery,
  useLazyGetTutorDetailsQuery,
  useLazyGetnextTutorByIdQuery,
} from "../../../services/tutor";
import { EmbedPDF } from "@simplepdf/react-embed-pdf";
import Loader from "../../../helpers/Loader";
import { useLazyGetDocucmentsDetailsQuery } from "../../../services/documentation";
import moment from "moment";
import { errorToast } from "../../../helpers";
import ActivityHistoryTutor from "../../../features/tutor/ActivityHistory";
import Classes from "../../../features/viewTutorDetails/Classes";
import TeaserVideos from "../../../features/viewTutorDetails/TeaserVideos";
import ShortVideos from "../../../features/viewTutorDetails/ShortVideos";
import Forum from "../../../features/viewTutorDetails/Forum";
import Posts from "../../../features/viewTutorDetails/Posts";
import {
  CURRICULUM,
  GRADE_TYPE_NAME,
  TEACHING_LANGUAGE,
  TEACHING_STYLE,
} from "../../../helpers/constants/enums";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const NextTutorDetail = () => {
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const [img, setImg] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);
  const [tutorDetails, setTutorDetails] = useState<any>(null);
  const [nextTutordata, setNextTutordata] = useState<any>([]);
  const [documents, setDocuments] = useState<any>([]);
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [getTutorById, { isLoading }] = useLazyGetTutorDetailsQuery();
  const [nextTutor] = useLazyGetnextTutorByIdQuery();
  const { _id } = useParams();
  const [getTeachingDetails] = useLazyGetTeachingDetailsByIdQuery();
  const [getDocs] = useLazyGetDocucmentsDetailsQuery();

  const fetchDataById = async (_id: any) => {
    try {
      const response = await getTutorById({ id: _id }).unwrap();
      if (response.statusCode === 200 && response.data.length > 0) {
        setTutorDetails(response.data[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const nextById = async (_id: any) => {
    try {
      const response = await nextTutor({ userId: _id }).unwrap();
      if (response.statusCode === 200) {
        setNextTutordata(response?.data);
        navigate(
          `/manage-tutor/details/NextTutorDetail/${response?.data?._id}`
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getTeaching = async (id: string) => {
    try {
      await getTeachingDetails({ userId: id }).unwrap();
    } catch (error: any) {
      errorToast("No next tutor available");
      navigate("/manage-tutors");
    }
  };

  const nameFun = (num: number) => {
    switch (num) {
      case 1:
        return "Education Documents";
      case 2:
        return "Police Clearance Letter";
      case 3:
        return "National Identification Scan";
      case 4:
        return "Headshot image";
      case 5:
        return "Selfie Scan";
      default:
        return "Id proof";
    }
  };

  const fetchDocs = async (id: string) => {
    try {
      const res = await getDocs({ userId: id }).unwrap();
      if (res?.statusCode === 200) {
        setDocuments(res?.data);
      }
    } catch (error: any) {
      errorToast(error?.data?.message);
    }
  };

  useEffect(() => {
    if (_id) {
      fetchDataById(_id);
      getTeaching(_id);
      fetchDocs(_id);
    }
  }, [_id]);

  const hasExperienceDocs = documents?.some(
    (item: any) => item?.documentType === 2 && item?.frontImage
  );
  const hasIdProofDocs = documents?.some(
    (item: any) => item?.documentType === 4 && item?.frontImage
  );
  const hasEducationDocs = documents?.some(
    (item: any) => item?.documentType === 3 && item?.frontImage
  );

  if (!tutorDetails) return <Loader isLoad={true} />;

  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">View Tutor Profile</h1>

          {_id && state?.userStatus !== "DELETED" && (
            <Button className="btn btn_primary" onClick={() => nextById(_id)}>
              Next
            </Button>
          )}
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-tutors")}
          >
            Back
          </Button>
        </div>

        <Loader isLoad={isLoading} />

        <Card className="cards">
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2} className="view_box">
              <Grid item lg={2} md={2} sm={6} xs={12}>
                <figure
                  className="profile_img"
                  onClick={() => {
                    setOpen(true);
                    setImg(tutorDetails?.image);
                  }}
                >
                  <img
                    src={
                      tutorDetails?.image ||
                      `/static/images/user_placeholder.png`
                    }
                    alt="Tutor profile"
                  />
                </figure>
              </Grid>

              <Grid item xs={10} className="view_box_list">
                <Grid container spacing={3}>
                  {/* Basic Info */}
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Name</Typography>
                      <Typography component="p">
                        {tutorDetails?.name || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Username</Typography>
                      <Typography component="p">
                        {tutorDetails?.userName || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Email</Typography>
                      <Typography component="p">
                        {tutorDetails?.email || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Phone no</Typography>
                      <Typography component="p">
                        {tutorDetails?.dialCode || ""}{" "}
                        {tutorDetails?.phoneNo || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Date Of Birth</Typography>
                      <Typography component="p">
                        {tutorDetails?.age
                          ? moment(tutorDetails.age).format("DD-MM-YYYY")
                          : "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Gender</Typography>
                      <Typography component="p">
                        {tutorDetails?.gender === "MALE"
                          ? "Male"
                          : tutorDetails?.gender === "FEMALE"
                            ? "Female"
                            : "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Timezone</Typography>
                      <Typography component="p">
                        {tutorDetails?.timezone || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Followers</Typography>
                      <Typography component="p">
                        {tutorDetails?.followers || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Views</Typography>
                      <Typography component="p">
                        {tutorDetails?.views || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Teaching Info */}
                  {tutorDetails?.teachingdetails && (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="h6">Teaching Details</Typography>
                      </Grid>

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">
                            Total Teaching Experience
                          </Typography>
                          <Typography component="p">
                            {`${
                              tutorDetails?.teachingdetails
                                ?.totalTeachingExperience || 0
                            } years`}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Price/hour</Typography>
                          <Typography component="p">
                            {tutorDetails?.teachingdetails?.price || "-"}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Achievement</Typography>
                          <Typography component="p">
                            {tutorDetails?.teachingdetails?.achievement || "-"}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Specialization</Typography>
                          <Typography component="p">
                            {tutorDetails?.teachingdetails?.specialization ||
                              "-"}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">
                            Teaching Language
                          </Typography>
                          <Typography component="p">
                            {tutorDetails?.teachingdetails?.teachingLanguage ===
                            TEACHING_LANGUAGE.ENGLISH
                              ? "English"
                              : tutorDetails?.teachingdetails
                                    ?.teachingLanguage ===
                                  TEACHING_LANGUAGE.ARABIC
                                ? "Arabic"
                                : "English, Arabic"}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Subjects</Typography>
                          <Typography component="p">
                            {tutorDetails?.subjectIds?.map(
                              (item: any, index: number) =>
                                index === 0 ? item?.name : `, ${item?.name}`
                            ) || "-"}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Classes</Typography>
                          <Typography component="p">
                            {tutorDetails?.teachingdetails?.classes?.length
                              ? tutorDetails?.teachingdetails?.classes
                                  .map((item: any, index: number) =>
                                    index === 0
                                      ? GRADE_TYPE_NAME[item]
                                      : `, ${GRADE_TYPE_NAME[item]}`
                                  )
                                  .join("")
                              : "-"}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Teaching Style</Typography>
                          <Typography component="p">
                            {tutorDetails?.teachingdetails?.teachingStyle
                              ?.length
                              ? tutorDetails?.teachingdetails?.teachingStyle
                                  .map((item: number, index: number) =>
                                    index === 0
                                      ? TEACHING_STYLE[
                                          item as keyof typeof TEACHING_STYLE
                                        ]
                                      : `, ${
                                          TEACHING_STYLE[
                                            item as keyof typeof TEACHING_STYLE
                                          ]
                                        }`
                                  )
                                  .join("")
                              : "-"}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Curriculum</Typography>
                          <Typography component="p">
                            {tutorDetails?.teachingdetails?.curriculum?.length
                              ? tutorDetails?.teachingdetails?.curriculum
                                  .map((item: number, index: number) =>
                                    index === 0
                                      ? CURRICULUM[
                                          item as keyof typeof CURRICULUM
                                        ]
                                      : `, ${
                                          CURRICULUM[
                                            item as keyof typeof CURRICULUM
                                          ]
                                        }`
                                  )
                                  .join("")
                              : "-"}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">
                            Curriculum Other
                          </Typography>
                          <Typography component="p">
                            {tutorDetails?.teachingdetails?.curriculumOther ||
                              "-"}
                          </Typography>
                        </Box>
                      </Grid>
                    </>
                  )}

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Short Bio</Typography>
                      <Typography component="p">
                        {tutorDetails?.shortBio || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box>
                      <Typography component="h5">Address</Typography>
                      <Typography component="p">
                        {tutorDetails?.address || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Account Status</Typography>
                      <Typography component="p">
                        {tutorDetails?.isBlocked === false
                          ? "Active"
                          : "Blocked"}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Bank Details */}
                  {tutorDetails?.bankdetails && (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="h6">Bank Details</Typography>
                      </Grid>
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">
                            Account Holder Name
                          </Typography>
                          <Typography component="p">
                            {tutorDetails?.bankdetails?.accountHolderName ||
                              "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Account Number</Typography>
                          <Typography component="p">
                            {tutorDetails?.bankdetails?.accountNumber || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Bank Name</Typography>
                          <Typography component="p">
                            {tutorDetails?.bankdetails?.bankName || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">Swift Code</Typography>
                          <Typography component="p">
                            {tutorDetails?.bankdetails?.swiftCode || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                    </>
                  )}

                  {/* Earning Details */}
                  <Grid item xs={12}>
                    <Typography variant="h6">Earning</Typography>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Class Earn</Typography>
                      <Typography component="p">
                        {tutorDetails?.classEarn || "0"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Gifts Earn</Typography>
                      <Typography component="p">
                        {tutorDetails?.giftsEarn || "0"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">One-On-One Earn</Typography>
                      <Typography component="p">
                        {tutorDetails?.oneOnOneEarn || "0"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Total Earn</Typography>
                      <Typography component="p">
                        {tutorDetails?.totalEarn || "0"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Balance</Typography>
                      <Typography component="p">
                        {tutorDetails?.balance || "0"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">Withdraw Amount</Typography>
                      <Typography component="p">
                        {tutorDetails?.withdrawAmount || "0"}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Documents Section */}
                  {hasIdProofDocs && (
                    <Grid item xs={12}>
                      <Box>
                        <Typography
                          component="h5"
                          style={{ padding: 15, fontSize: "15px" }}
                        >
                          Id Proof
                        </Typography>
                        <Box className="docs_div">
                          <Grid container spacing={2}>
                            {documents
                              .filter(
                                (item: any) =>
                                  item?.documentType === 4 && item?.frontImage
                              )
                              .map((item: any, index: number) => (
                                <Grid item xs={4} key={index}>
                                  {item?.frontImage?.endsWith(".pdf") ? (
                                    <div className="upload_pdf_preview">
                                      <EmbedPDF companyIdentifier="yourcompany">
                                        <a
                                          href={item?.frontImage}
                                          className="pdf_uplod"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <img
                                            src="/static/images/pdf.png"
                                            alt="PDF"
                                          />
                                          <h6>{nameFun(item?.documentName)}</h6>
                                        </a>
                                      </EmbedPDF>
                                    </div>
                                  ) : (
                                    <figure
                                      onClick={() => {
                                        setImg(item?.frontImage || "");
                                        setOpen(true);
                                      }}
                                    >
                                      <img
                                        src={item.frontImage}
                                        alt="ID Proof"
                                      />
                                    </figure>
                                  )}
                                </Grid>
                              ))}
                          </Grid>
                        </Box>
                      </Box>
                    </Grid>
                  )}

                  {hasExperienceDocs && (
                    <Grid item xs={12}>
                      <Box>
                        <Typography
                          component="h5"
                          style={{ padding: 15, fontSize: "15px" }}
                        >
                          Experience
                        </Typography>
                        <Box className="docs_div">
                          <Grid container spacing={2}>
                            {documents
                              .filter(
                                (item: any) =>
                                  item?.documentType === 2 && item?.frontImage
                              )
                              .map((item: any, index: number) => (
                                <Grid item xs={4} key={index}>
                                  {item?.frontImage?.endsWith(".pdf") ? (
                                    <div
                                      className="upload_pdf_preview"
                                      style={{ marginLeft: "16px" }}
                                    >
                                      <EmbedPDF companyIdentifier="yourcompany">
                                        <a
                                          href={item?.frontImage}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="pdf_uplod"
                                        >
                                          <img
                                            src="/static/images/pdf.png"
                                            alt="PDF"
                                          />
                                          <h6>Experience Letter</h6>
                                        </a>
                                      </EmbedPDF>
                                    </div>
                                  ) : (
                                    <figure
                                      onClick={() => {
                                        setOpen(true);
                                        setImg(item?.frontImage || "");
                                      }}
                                    >
                                      <img
                                        src={item.frontImage}
                                        alt="Achievement"
                                      />
                                    </figure>
                                  )}
                                </Grid>
                              ))}
                          </Grid>
                        </Box>
                      </Box>
                    </Grid>
                  )}

                  {hasEducationDocs && (
                    <Grid item xs={12}>
                      <Box>
                        <Typography
                          component="h5"
                          style={{ padding: 15, fontSize: "15px" }}
                        >
                          Education
                        </Typography>
                        <Box className="docs_div">
                          <Grid container spacing={2}>
                            {documents
                              .filter(
                                (item: any) =>
                                  item?.documentType === 3 && item?.frontImage
                              )
                              .map((item: any, index: number) => (
                                <Grid item xs={4} key={index}>
                                  {item?.frontImage?.endsWith(".pdf") ? (
                                    <div
                                      className="upload_pdf_preview"
                                      style={{ marginLeft: "16px" }}
                                    >
                                      <EmbedPDF companyIdentifier="yourcompany">
                                        <a
                                          href={item?.frontImage}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="pdf_uplod"
                                        >
                                          <img
                                            src="/static/images/pdf.png"
                                            alt="PDF"
                                          />
                                          <h6>Certificate</h6>
                                        </a>
                                      </EmbedPDF>
                                    </div>
                                  ) : (
                                    <figure
                                      onClick={() => {
                                        setImg(item?.frontImage || "");
                                        setOpen(true);
                                      }}
                                    >
                                      <img
                                        src={item.frontImage}
                                        alt="Certification"
                                      />
                                    </figure>
                                  )}
                                </Grid>
                              ))}
                          </Grid>
                        </Box>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Tabs Section */}
        <Card sx={{ mt: 4 }} className="cards">
          <Box className="custom_tabs">
            <Box className="flx_sc">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Earnings" {...a11yProps(0)} />
                <Tab label="Activity History" {...a11yProps(1)} />
                <Tab label="Ratings" {...a11yProps(2)} />
                <Tab label="Teaser Video" {...a11yProps(3)} />
                <Tab label="Short Video" {...a11yProps(4)} />
                <Tab label="Classes" {...a11yProps(5)} />
                <Tab label="Forums" {...a11yProps(6)} />
                <Tab label="Posts" {...a11yProps(7)} />
              </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
              <Earning />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <ActivityHistoryTutor />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <TutorRating />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <TeaserVideos />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
              <ShortVideos />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={5}>
              <Classes />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={6}>
              <Forum />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={7}>
              <Posts />
            </CustomTabPanel>
          </Box>
        </Card>
      </div>

      <DocumentViewer open={open} setOpen={setOpen} img={img} />
    </MainContainer>
  );
};

export default NextTutorDetail;
